module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Cd-Db-Ef-Gc.6af9d44c.png";